export default __webpack_public_path__ + "static/media/FundoLoteamento.a2aea39f.jpg";